module.exports = __webpack_public_path__ + "img/cyan_crown_three_peaks.ba92abe8.png";